var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.2 332.167C135.409 337.937 127.422 352.443 133.811 364.311",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.978 308.789C95.8801 320.478 68.0216 350.285 77.3727 376",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3059 259.111C54.4818 253.266 83.8015 233.687 103.673 202.127",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6887 311.712C56.5454 307.816 80.2804 294.763 96.3666 273.723",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.356 113C130.459 125.176 119.745 143.683 72.9889 159.756C60.326 162.678 35 175.243 35 202.128",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390.201 332.167C394.992 337.937 402.979 352.443 396.59 364.311",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.423 308.789C434.521 320.478 462.379 350.285 453.028 376",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M488.095 259.111C475.919 253.266 446.599 233.687 426.728 202.127",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.712 311.712C473.855 307.816 450.12 294.763 434.034 273.723",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M396.045 113C399.942 125.176 410.656 143.683 457.412 159.756C470.075 162.678 495.401 175.243 495.401 202.128",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.869,
    cy: 236.934,
    rx: 28.911,
    ry: 12.9339,
    fill: "#1C1B1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.63 249.107V283.436C265.63 284.741 264.787 285.891 263.539 286.27C257.561 288.089 250.362 290.473 243.567 302.364C241.828 305.407 238.241 309.424 231.394 309.972C225.054 310.479 212.525 304.19 213.134 281.061",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.87 249.107V283.436C264.87 284.741 265.713 285.891 266.961 286.27C272.939 288.089 280.138 290.473 286.933 302.364C288.672 305.407 292.259 309.424 299.106 309.972C305.446 310.479 317.975 304.19 317.366 281.061",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M473 418L438 383",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 380.082,
    cy: 315.082,
    r: 90.5819,
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415 275C420.46 275 424.887 278.473 424.887 282.758L424.887 293.101C424.887 297.386 420.46 300.859 415 300.859C409.539 300.859 405.113 297.386 405.113 293.101L405.113 282.758C405.113 278.473 409.539 275 415 275Z",
    fill: "#1C1B1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415 354.099C420.46 354.099 424.887 357.981 424.887 362.769L424.887 374.33C424.887 379.118 420.46 383 415 383C409.539 383 405.113 379.118 405.113 374.33L405.113 362.769C405.113 357.981 409.539 354.099 415 354.099Z",
    fill: "#1C1B1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.879 290.104C456.205 293.43 456.205 298.823 452.879 302.149L444.849 310.179C441.523 313.505 436.13 313.505 432.804 310.179C429.478 306.853 429.478 301.46 432.804 298.134L440.834 290.104C444.16 286.778 449.553 286.778 452.879 290.104Z",
    fill: "#1C1B1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.865 347.116C399.191 350.442 399.191 355.835 395.865 359.161L387.835 367.191C384.509 370.517 379.116 370.517 375.79 367.191C372.464 363.865 372.464 358.472 375.79 355.146L383.82 347.116C387.146 343.79 392.539 343.79 395.865 347.116Z",
    fill: "#1C1B1F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.104 290.103C379.43 286.777 384.823 286.777 388.149 290.103L396.179 298.133C399.505 301.459 399.505 306.852 396.179 310.178C392.853 313.504 387.46 313.504 384.134 310.178L376.104 302.148C372.778 298.822 372.778 293.429 376.104 290.103Z",
    fill: "#1C1B1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.116 347.116C436.442 343.79 441.835 343.79 445.161 347.116L453.191 355.146C456.517 358.472 456.517 363.865 453.191 367.191C449.865 370.517 444.472 370.517 441.146 367.191L433.116 359.161C429.79 355.835 429.79 350.442 433.116 347.116Z",
    fill: "#1C1B1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361 327.479C361 322.858 364.473 319.113 368.758 319.113L379.101 319.113C383.386 319.113 386.859 322.858 386.859 327.479C386.859 332.1 383.386 335.845 379.101 335.845L368.758 335.845C364.473 335.845 361 332.1 361 327.479Z",
    fill: "#1C1B1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.099 327.479C440.099 322.858 443.981 319.113 448.769 319.113L460.33 319.113C465.118 319.113 469 322.858 469 327.479C469 332.1 465.118 335.845 460.33 335.845L448.769 335.845C443.981 335.845 440.099 332.1 440.099 327.479Z",
    fill: "#1C1B1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M449 327.5C449 346.002 433.778 361 415 361C396.222 361 381 346.002 381 327.5C381 308.998 396.222 294 415 294C433.778 294 449 308.998 449 327.5Z",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M429.901 327.451C429.901 335.432 423.431 341.901 415.45 341.901C407.47 341.901 401 335.432 401 327.451C401 319.47 407.47 313 415.45 313C423.431 313 429.901 319.47 429.901 327.451Z",
    fill: "#1C1B1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.08 261C332.616 261 334.672 262.613 334.672 264.603L334.672 269.407C334.672 271.397 332.616 273.01 330.08 273.01C327.544 273.01 325.488 271.397 325.488 269.407L325.488 264.603C325.488 262.613 327.544 261 330.08 261Z",
    fill: "#1C1B1F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.08 297.737C332.616 297.737 334.672 299.54 334.672 301.764L334.672 307.134C334.672 309.358 332.616 311.16 330.08 311.16C327.544 311.16 325.488 309.358 325.488 307.134L325.488 301.764C325.488 299.54 327.544 297.737 330.08 297.737Z",
    fill: "#1C1B1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.673 268.015C349.217 269.56 349.217 272.064 347.673 273.609L343.943 277.339C342.398 278.883 339.894 278.883 338.349 277.339C336.804 275.794 336.804 273.289 338.349 271.744L342.078 268.015C343.623 266.47 346.128 266.47 347.673 268.015Z",
    fill: "#1C1B1F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.193 294.494C322.738 296.039 322.738 298.543 321.193 300.088L317.464 303.818C315.919 305.362 313.414 305.362 311.869 303.818C310.325 302.273 310.325 299.768 311.869 298.223L315.599 294.494C317.144 292.949 319.648 292.949 321.193 294.494Z",
    fill: "#1C1B1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.015 268.014C313.56 266.47 316.065 266.47 317.609 268.014L321.339 271.744C322.884 273.289 322.884 275.793 321.339 277.338C319.794 278.883 317.289 278.883 315.745 277.338L312.015 273.609C310.47 272.064 310.47 269.559 312.015 268.014Z",
    fill: "#1C1B1F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.494 294.494C340.039 292.949 342.544 292.949 344.088 294.494L347.818 298.223C349.363 299.768 349.363 302.273 347.818 303.818C346.273 305.362 343.768 305.362 342.224 303.818L338.494 300.088C336.949 298.543 336.949 296.039 338.494 294.494Z",
    fill: "#1C1B1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305 285.374C305 283.228 306.613 281.488 308.603 281.488L313.407 281.488C315.397 281.488 317.01 283.228 317.01 285.374C317.01 287.52 315.397 289.259 313.407 289.259L308.603 289.259C306.613 289.259 305 287.52 305 285.374Z",
    fill: "#1C1B1F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.737 285.374C341.737 283.228 343.54 281.488 345.764 281.488L351.133 281.488C353.357 281.488 355.16 283.228 355.16 285.374C355.16 287.52 353.357 289.259 351.133 289.259H345.764C343.54 289.259 341.737 287.52 341.737 285.374Z",
    fill: "#1C1B1F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M344.373 284.462C344.373 292.654 337.732 299.294 329.541 299.294C321.349 299.294 314.708 292.654 314.708 284.462C314.708 276.271 321.349 269.63 329.541 269.63C337.732 269.63 344.373 276.271 344.373 284.462Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M336.222 284.432C336.222 288.138 333.217 291.143 329.51 291.143C325.804 291.143 322.799 288.138 322.799 284.432C322.799 280.725 325.804 277.72 329.51 277.72C333.217 277.72 336.222 280.725 336.222 284.432Z",
    fill: "#1C1B1F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M181 158C218.333 162.651 304.2 178.163 349 203",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M349 158C311.667 162.651 225.8 178.163 181 203",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379 242C371.268 242 365 248.268 365 256C365 263.732 371.268 270 379 270C386.732 270 393 263.732 393 256C393 248.268 386.732 242 379 242Z",
    fill: "#1C1B1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.5 314C307.91 314 305 316.91 305 320.5C305 324.09 307.91 327 311.5 327C315.09 327 318 324.09 318 320.5C318 316.91 315.09 314 311.5 314Z",
    fill: "#1C1B1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.5 249C417.91 249 415 251.91 415 255.5C415 259.09 417.91 262 421.5 262C425.09 262 428 259.09 428 255.5C428 251.91 425.09 249 421.5 249Z",
    fill: "#1C1B1F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.5 376C371.91 376 369 378.91 369 382.5C369 386.09 371.91 389 375.5 389C379.09 389 382 386.09 382 382.5C382 378.91 379.09 376 375.5 376Z",
    fill: "#1C1B1F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.5 342C320.283 342 312 350.283 312 360.5C312 370.717 320.283 379 330.5 379C340.717 379 349 370.717 349 360.5C349 350.283 340.717 342 330.5 342Z",
    fill: "#1C1B1F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345 323C342.239 323 340 325.239 340 328C340 330.761 342.239 333 345 333C347.761 333 350 330.761 350 328C350 325.239 347.761 323 345 323Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/피부과-dog.7cd0a7cdb9c96b41e2610a366f057c58.svg";
export { ForwardRef as ReactComponent };